module.exports = __webpack_public_path__ + "sx.svg?86cf183abda12f22953b28dcbcda7eab";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/sx.svg
// module id = 1386
// module chunks = 27